// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedEmployeeLeaveSetting: null
}

const employeeLeaveSettings = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_EMPLOYEE_LEAVE_SETTINGS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_EMPLOYEE_LEAVE_SETTINGS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_EMPLOYEE_LEAVE_SETTING':
      return { ...state, selectedEmployeeLeaveSetting: action.selectedEmployeeLeaveSetting }
    case 'ADD_EMPLOYEE_LEAVE_SETTING':
      return { ...state }
    case 'DELETE_EMPLOYEE_LEAVE_SETTING':
      return { ...state }
    default:
      return { ...state }
  }
}
export default employeeLeaveSettings
